import * as React from "react";
import { useCallback, useEffect } from "react";
import styled from "styled-components";
import { Button, Modal } from "components/bootstrap";
import ModalButtonToolbar from "components/common/ModalButtonToolbar";
import { Spinner, Icon } from "components/common";
const StyledIcon = styled(Icon)`
  padding-right: 0.5rem;
`;
function Buttons({ onConfirm, onCancel, noCancelButton, confirmText, confirmDisabled, isLoading }) {
  return /* @__PURE__ */ React.createElement(ModalButtonToolbar, null, noCancelButton || /* @__PURE__ */ React.createElement(Button, { onClick: onCancel }, "Cancel"), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: onConfirm, disabled: confirmDisabled || isLoading }, isLoading && /* @__PURE__ */ React.createElement(Spinner, { text: "" }), " ", confirmText));
}
function ConfirmDialog({
  show,
  title,
  type = "default",
  onConfirm,
  onCancel = () => {
  },
  noCancelButton = false,
  confirmText = "Confirm",
  confirmDisabled = false,
  isLoading = false,
  children
}) {
  const handleClose = useCallback(() => {
    if (noCancelButton) onConfirm();
    onCancel();
  }, [onCancel, onConfirm, noCancelButton]);
  useEffect(() => {
    if (!show) {
      return void 0;
    }
    const listener = (e) => {
      e.stopPropagation();
      if (e.key === "Enter") onConfirm();
    };
    document.addEventListener("keydown", listener, true);
    return () => {
      document.removeEventListener("keydown", listener, true);
    };
  }, [show, onConfirm]);
  useEffect(() => {
    if (!show) {
      return void 0;
    }
    const listener = (e) => {
      e.stopPropagation();
      if (e.key === "Escape") handleClose();
    };
    document.addEventListener("keydown", listener, true);
    return () => {
      document.removeEventListener("keydown", listener, true);
    };
  }, [show, handleClose]);
  const titleByType = {
    danger: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StyledIcon, { className: "text-danger", name: "cancel" }), " ", title),
    warning: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StyledIcon, { className: "text-warning", name: "warning" }), " ", title),
    info: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StyledIcon, { className: "text-info", name: "error" }), " ", title),
    success: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StyledIcon, { className: "text-success", name: "exclamation" }), " ", title),
    default: title
  };
  return /* @__PURE__ */ React.createElement(Modal, { show, onHide: handleClose, isConfirmDialog: true }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, titleByType[type])), /* @__PURE__ */ React.createElement(Modal.Body, null, children), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    Buttons,
    {
      onConfirm,
      onCancel: handleClose,
      noCancelButton,
      confirmText,
      confirmDisabled,
      isLoading
    }
  )));
}
export default ConfirmDialog;
